import { render, staticRenderFns } from "./UploadFileOrLink.vue?vue&type=template&id=36a2be7b&scoped=true&"
import script from "./UploadFileOrLink.vue?vue&type=script&lang=js&"
export * from "./UploadFileOrLink.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileOrLink.vue?vue&type=style&index=0&id=36a2be7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2be7b",
  null
  
)

export default component.exports